module.exports = __webpack_public_path__ + "assets/img/creationMng_(31).6ffa9306.png";